import type { VendorMetadataExtractor, ExtractedIncidentMeta } from './types'

export const garminExtractor: VendorMetadataExtractor = {
  vendorId: 'garmin',
  vendorLabel: 'Garmin',
  supportsDirectoryBrowse: false,

  async extractFromFiles(files: File[]): Promise<ExtractedIncidentMeta | null> {
    // Garmin embeds GPS in proprietary `eeGPS` MP4 atoms. Parsing these requires
    // ExifTool (not available in-browser without WASM). Falls back to file timestamp.
    const first = files[0]
    if (!first) return null
    return { dateTime: new Date(first.lastModified) }
  }
}
